import { DateInput } from "@/common/components/DateInput/DateInput";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";
import { format, isValid, parse } from "date-fns";
import { useForm } from "react-hook-form";

const DashboardFilterStartDateHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const { control } = useForm<{ date: string }>();

  const dateValue = value instanceof Date && isValid(value)
    ? format(value, "dd/MM/yyyy")
    : undefined;

  return (
    <DateInput
      fieldName="date"
      label="Selecione a data inicial"
      markAsRequired
      control={control}
      value={dateValue}
      handleChange={(val) => {
        if (!val || val.length < 10) {
          onChange(undefined);
          return;
        }

        const parsed = parse(val, "dd/MM/yyyy", new Date());
        onChange(isValid(parsed) ? parsed : undefined);
      }}
    />
  );
}

export default DashboardFilterStartDateHiddenFilter;
